import {createContext} from 'react'

import {AnalyticsMethods} from './types'

export const AnalyticsQueueContext = createContext<AnalyticsMethods>({
  linkClickLogEvent: () => undefined,
  logEvent: () => undefined,
  pageViewLogEvent: () => undefined,
  setUserProperties: () => undefined,
})
